module.exports = __webpack_public_path__ + "static/media/activeAvailable.82b63b2b.svg";